/**
 * Parse NestJS-style JSON error bodies from /api/ai/* endpoints.
 */

export function parseNestErrorMessage(payload: unknown): string {
  if (!payload || typeof payload !== "object") return "";
  const msg = (payload as { message?: unknown }).message;
  if (typeof msg === "string") return msg;
  if (Array.isArray(msg) && msg.length > 0 && typeof msg[0] === "string") return msg[0];
  return "";
}

export function isInsufficientTokensMessage(message: string): boolean {
  return /insufficient tokens|not enough tokens/i.test(message);
}

/** Matches server copy: "Insufficient tokens. Need 100 tokens for ..." or "You need 100 tokens" */
export function parseRequiredTokensFromMessage(message: string): number | null {
  const needMatch = message.match(/Need (\d+) tokens/i);
  if (needMatch) return Number(needMatch[1]);
  const youNeedMatch = message.match(/You need (\d+) tokens/i);
  return youNeedMatch ? Number(youNeedMatch[1]) : null;
}
